<template>
  <div class="nav_wrap">
    <div class="logo">
      <img :src="siteInfo.logo" />
    </div>

    <div class="nav">
      <div class="nav-a">
        <ul class="nav-a-ul">
          <li
            v-for="(item, index) in navList"
            :key="index"
            class="nav-a-li"
            :class="classA == item.id ? 'active' : ''"
            @click="selected(item.id)"
          >
            <router-link
              :to="item.url"
              class="nav-a-text"
              @click="showToggle(item.id)"
            >
              {{ item.title }}
            </router-link>
            <ul class="menu_ul" :class="{ active: item.id === isShow }">
              <li
                v-for="nav in item.subItems"
                :key="nav.link"
                class="menu_li"
                :class="classB == nav ? 'active' : ''"
                @click="menuselected(nav)"
              >
                <router-link
                  class="menu_ul_text"
                  :to="nav.link"
                  :class="{ active: nav.link == linkClick }"
                  @click="treeNavSwitch(nav)"
                >
                  {{ nav.text }}
                </router-link>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Nav",
  // props: ["siteLogo"],
  data() {
    return {
      show: false,
      classA: 1,
      classB: 1,
      isShow: 1,
      linkClick: "",
      navList: [
        { title: "首页", url: "/", id: 1 },
        { title: "物流查询", url: "/search", id: 2 },
        { title: "企业介绍", url: "/company", id: 3 },
        { title: "新闻中心", url: "/news", id: 4 },
        { title: "联系城际", url: "/contact", id: 5 },
      ],
      logoimg: require("../assets/img/logo.png"),
      siteInfo:{}
    };
  },
  created() {
    let that = this;
    let path = this.$route.path;
    this.navList.map(function (obj) {
      // 使用element访问数组中的每个元素
      if (path == obj.url) {
        that.classA = obj.id;
      }
    });
    that.siteInfo = this.commFunc.getSession('setSiteInfoByStore')
  },
  methods: {
    selected(index) {
      this.classA = index;
    },
    menuselected(nav) {
      this.classB = nav;
    },
    showToggle(index) {
      this.isShow = index;
    },
    treeNavSwitch(nav) {
      this.linkClick = nav.link;
    },
  },
};
</script>
<style scoped>
.nav_wrap {
  position: fixed;
  width: 100%;
  background-color: rgba(255, 255, 255, 1);
  box-shadow: 0px 2px 16px rgba(0, 0, 0, 0.1);
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 0;
  z-index: 99999999;
}

.nav_wrap > .logo > img {
  height: 54px;
  margin-left: 5rem;
  border-radius: 0.3rem;
}

.nav {
  height: auto;
  margin-right: 50px;
  border-bottom: none;
  line-height: 65px;
}
.nav-a {
  cursor: pointer;
  float: left;
  margin-left: 50px;
  letter-spacing: 4px;
  position: relative;
}
.nav-a-ul {
  list-style: none;
}
.nav-a-li {
  display: inline-block;
  margin-left: 30px;
  height: 60px;
}
.nav-a-text {
  font-size: 16px;
  color: #000;
  line-height: 58px;
  text-decoration: none;
}
.menu_ul {
  width: 20%;
  list-style: none;
  background: #fff;
  border-radius: 3px;
  z-index: 999;
  position: absolute;
  top: 58px;
  left: 67px;
  display: none;
}

.menu_li {
  height: 30px;
  line-height: 30px;
  padding: 10px 0px 10px 12px;
}
.menu_ul_text {
  font-size: 16px;
  color: #666;
  letter-spacing: 0;
  line-height: 30px;
  text-decoration: none;
  padding-left: 6px;
}
.nav-a-li:hover {
  border-bottom: 2px solid #290ad7;
}
.nav-a-li.active {
  border-bottom: 2px solid #290ad7;
}
.nav-a-li:hover .menu_ul {
  display: block;
}
.menu_ul_text:hover {
  color: #2589ff;
}
.menu_li.active .menu_ul_text {
  color: #2589ff;
}
</style>
